import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Comparison() {
  const bad = ['Comidas improvisadas', 'Inflamación frecuente', 'Falta de energía', 'Estrés con las comidas', 'Mala organización', 'Dieta aburrida', 'Riesgo de contaminación cruzada'];
  const good = ['Alimentación organizada', 'Más energía', 'Recetas fáciles', 'Menos estrés', 'Mejor digestión', 'Hábitos saludables', 'Más tranquilidad diaria'];
  return <section className="py-20 px-4 bg-warm-white" data-id="element-25">
      <div className="max-w-5xl mx-auto" data-id="element-26">
        <div className="text-center mb-16" data-id="element-27">
          <h2 className="font-serif text-4xl md:text-5xl text-forest mb-4" data-id="element-28">
            LA REALIDAD
          </h2>
          <p className="text-xl text-muted" data-id="element-29">
            ¿Qué pasa cuando no organizás tu alimentación?
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-30">
          {/* Bad Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#D97757]/10 border border-terracotta/30 rounded-3xl p-8 md:p-10" data-id="element-31">
            <h3 className="font-serif text-2xl text-terracotta mb-8 text-center" data-id="element-32">
              Sin el sistema
            </h3>
            <ul className="space-y-5" data-id="element-33">
              {bad.map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-34">
                  <div className="w-8 h-8 rounded-full bg-terracotta/20 flex items-center justify-center flex-shrink-0" data-id="element-35">
                    <X className="w-5 h-5 text-terracotta" data-id="element-36" />
                  </div>
                  <span className="text-charcoal font-medium" data-id="element-37">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Good Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#4A7C59]/10 border border-sage/30 rounded-3xl p-8 md:p-10 relative overflow-hidden" data-id="element-38">
            <div className="absolute top-0 right-0 w-32 h-32 bg-sage/10 rounded-full blur-3xl -mr-10 -mt-10" data-id="element-39"></div>
            <h3 className="font-serif text-2xl text-forest mb-8 text-center relative z-10" data-id="element-40">
              Con el sistema
            </h3>
            <ul className="space-y-5 relative z-10" data-id="element-41">
              {good.map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-42">
                  <div className="w-8 h-8 rounded-full bg-sage/20 flex items-center justify-center flex-shrink-0" data-id="element-43">
                    <Check className="w-5 h-5 text-forest" data-id="element-44" />
                  </div>
                  <span className="text-charcoal font-medium" data-id="element-45">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}